import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation} from "swiper/modules";
import CardSlide from "./CardSlide";
import React from "react";
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import {cardMatchesDeckFilter} from "../../../utils/cardFilters";
import Filter from "../helpers/Filter";

function LibSlider() {

    const {user, cards, deckEditorFilter} = useTypedSelector(state => state.auth);

    return <div className={'librarySliderContainer'}>
        <div className="library-slider">
            <Swiper
                modules={[Navigation]}
                spaceBetween={7}
                loop={false}
                threshold={10}
                touchRatio={1}
                touchStartPreventDefault={true}
                navigation={{
                    prevEl: '.swiper-button-prev-lib',
                    nextEl: '.swiper-button-next-lib',
                }}
                breakpoints={{
                    0: {
                        slidesPerView: 5, // phones, tablets, small laptops
                    },
                    2200: {
                        slidesPerView: 7, // full HD+ desktops
                    },
                }}
            >
                {Object.keys(user.library.cards)
                    .filter(item => {
                        const cardId = user.library.cards[item].id;
                        return cardMatchesDeckFilter(cardId, cards[cardId], deckEditorFilter);
                    })
                    .map((item, index) => {

                        if (user.deck.cards === null) {
                            return;
                        }

                        const cardId = user.library.cards[item].id;
                        const libAmount = user.library.cards[item].amount;
                        let deckAmount = 0;
                        if (user.deck.cards[cardId] !== undefined) {
                            // @ts-ignore
                            deckAmount = user.deck.cards[cardId].amount;
                        }
                        let canAddCard = ((deckAmount === 0 && libAmount !== 0) || (libAmount !== 0 && libAmount !== deckAmount && deckAmount < 5));

                        if (cardId === 1042 || cardId === 1043 || cardId === 1044) {
                            canAddCard = ((deckAmount === 0 && libAmount !== 0) || (libAmount !== 0 && libAmount !== deckAmount && deckAmount < 10));
                        }

                        return <SwiperSlide key={index + '_library'}>

                            <CardSlide card={cards[cardId]} amount={libAmount} isDeck={false} addToDeck={canAddCard}/>

                        </SwiperSlide>;
                    })}

            </Swiper>
            <div className="swiper-button-prev swiper-button-prev-lib"></div>
            <div className="swiper-button-next swiper-button-next-lib"></div>
        </div>
      <Filter />
    </div>
}

export default LibSlider;